export default __webpack_public_path__ + "static/fundacja-e888e9d243b9221e673e1de934bd695d.svg";